// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.tenant.LeasingTenantWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetPaginatedLeasesForTenantWebApiResponseDto, GetTenantInfoWebApiResponseDto } from '../..';

interface GetPaginatedLeasesForTenantParams {
  numResults: number;
  offset: number;
}

export const LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_Path =
  '/api/web/v1/tenant/getPaginatedLeasesForTenant';

/**
 * get paginated leases for tenant
 */
export const LeasingTenantWebApiHandler_getPaginatedLeasesForTenant = (
  getParams: GetPaginatedLeasesForTenantParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetPaginatedLeasesForTenantParams, never, GetPaginatedLeasesForTenantWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeasingTenantWebApiHandler_getTenantInfo_Path = '/api/web/v1/tenant/getTenantInfo';

/**
 * get tenant information
 */
export const LeasingTenantWebApiHandler_getTenantInfo = (client = getClient()) => {
  return httpFrontEndRequest<never, never, GetTenantInfoWebApiResponseDto>(
    {
      endpoint: LeasingTenantWebApiHandler_getTenantInfo_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
